/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React, { useEffect, useState } from 'react';

// reactstrap components
import { Card, CardBody, CardTitle, Row, Col, Spinner } from "reactstrap";
// core components
import { getCredentials, getSubscriptions } from "../../../../network/ApiAxios.js";
import secureLocalStorage from "react-secure-storage";

const KPITeachers = (props) => {
  const [isLoading, setisLoading] = useState(false)
  const [teachers, setTeachers] = useState([])
  const [admins, setAdmins] = useState([])
  const user = JSON.parse(secureLocalStorage.getItem("user"));
  const app = JSON.parse(secureLocalStorage.getItem("app"));

  useEffect(() => {
    const runCountTeachers = async () => {
      setisLoading(true);

      let params = {
                filter : {
                },
                constraint: {
                    user: { account: user.account },
                    type: { isOwner: false }
                }
            }

      const response = await getCredentials(params);
      const { data } = response;

      if (data.success) {        
        let countTeachers=0
        let countADMs=0
        data.credentials.map(credential=>{
          if(credential.type.isTeacher){
            countTeachers+=1
          }
          if(credential.type.isADM){
            countADMs+=1
          }
        })
        setTeachers(countTeachers)
        setAdmins(countADMs)            
      }

      setisLoading(false);
    }

    runCountTeachers();

  }, []);

  return (
    <>
      <Card className="card-stats mb-4 mb-xl-0">
        {
          isLoading ?
            <div className="text-center p-5">
              <Spinner size="lg" />
            </div>
            :
            <CardBody>
              <Row>
                <div className="col">
                  <CardTitle
                    tag="h5"
                    className="text-uppercase text-muted mb-0"
                  >
                    Teachers
                  </CardTitle>
                  <span className="h2 font-weight-bold mb-0">{teachers}</span>
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-red text-white rounded-circle shadow">
                    <i className="fas fa-person-chalkboard" />
                  </div>
                </Col>
              </Row>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {1}
                </span>{" "}
                <span className="text-nowrap">Account Owner</span>
              </p>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {admins}
                </span>{" "}
                <span className="text-nowrap">Account Administrator</span>
              </p>
              <p className="mt-3 mb-0 text-muted text-sm">
                <span className="text-success mr-2">
                  {admins + teachers + 1}
                </span>{" "}
                <span className="text-nowrap">Total Users</span>
              </p>
            </CardBody>
        }
      </Card>
    </>
  );
};

export default KPITeachers;
